import React, { useEffect } from 'react'

import firebase from 'firebase/app'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'

import { useParams } from 'react-router-dom'

import { validateAction } from '@redux/actions/auth'
import store from '@redux/store'
import { useDispatch } from 'react-redux'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance } from 'redux-firestore'

import SafeWalkActionSheet from '@components/safewalk-action-sheet/safewalk-action-sheet.component'
import AddContactsFormActionSheet from '@components/add-contacts-form-action-sheet/add-contacts-form-action-sheet.component'
import EmergencyActionSheet from '@components/emergency-action-sheet/emergency-action-sheet.component'
import FirebaseConfig from '@components/firebase-config/firebase-config.component'
import PushContainer from '@components/push-container/push-container.component'
import AuthIsLoaded from '@components/auth-is-loaded/auth-is-loaded.component'
import InstallBanner from '@components/install-banner/install-banner.component'

import * as Sentry from '@sentry/browser'

const fbConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: 'prospector-b2360',
  messagingSenderId: '531410456808',
  appId: '1:531410456808:web:961e96de1554b985',
  measurementId: 'G-G937VS1DY8'
}

if (!firebase.apps.length) {
  try {
    firebase.initializeApp(fbConfig)

    firebase.analytics()
  
    firebase.firestore()
  
    firebase.firestore().settings({
      experimentalAutoDetectLongPolling: true
    })
  } catch (error) {
    Sentry.captureException(error)
  }
}

const rrfConfig = {}

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
}

const Push = () => {
  const { personalAccessCode } = useParams()

  const dispatch = useDispatch()

  useEffect(() => {
    if (personalAccessCode) {
      dispatch(validateAction({ personalAccessCode }))
    }
  }, [dispatch, personalAccessCode])

  return (
    <ReactReduxFirebaseProvider {...rrfProps}>
      <AuthIsLoaded>
        <FirebaseConfig>
          <PushContainer />
          <EmergencyActionSheet />
          <SafeWalkActionSheet />
          <AddContactsFormActionSheet />
          <InstallBanner />
        </FirebaseConfig>
      </AuthIsLoaded>
    </ReactReduxFirebaseProvider>
  )
}

export default Push
